module.exports = [
 {
  "start": 41,
  "end": 2125,
  "text": "Open my Glade was originally perceived "
 },
 {
  "start": 2208,
  "end": 4208,
  "text": "for one of the flashing Times Square screens "
 },
 {
  "start": 4291,
  "end": 5083,
  "text": "in New York. "
 },
 {
  "start": 5208,
  "end": 7458,
  "text": "It was produced by the Public Art Fund. "
 },
 {
  "start": 7708,
  "end": 9125,
  "text": "The figure in the box tries "
 },
 {
  "start": 9208,
  "end": 11458,
  "text": "to transgress the screen behind "
 },
 {
  "start": 11500,
  "end": 14333,
  "text": "which we stare and store all our knowledge, "
 },
 {
  "start": 14417,
  "end": 16542,
  "text": "communication and history today."
 },
 {
  "start": 16708,
  "end": 18291,
  "text": "her action is also a reaction "
 },
 {
  "start": 18333,
  "end": 21500,
  "text": "to the made-up and idealised presentation "
 },
 {
  "start": 21625,
  "end": 24500,
  "text": "which slaves us in the electronic media."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room3/audio4/03_4MCA Open My Glade.js